












































import Vue from 'vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlTextarea from '@/components/common/control/CtrlTextarea.vue';
import { BUTTON } from '@/constants/label';
import { ShoriKb } from '@/constants/constants';
import { isShorikbREFER } from '@/utils/utils';
import { mapGetters } from 'vuex';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default Vue.extend({
  name: 'G_040_HatchuEntry_RenrakuEntry',
  components: {
    CtrlNormalBtn,
    CtrlTextarea,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childHeaderInput: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    BUTTON,
    hatchuRenrakuJiko: '',
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  created() {
    if (
      this.childHeaderInput &&
      this.childHeaderInput.hatchuRenrakuJiko !== undefined
    ) {
      this.hatchuRenrakuJiko = this.childHeaderInput.hatchuRenrakuJiko;
    }
  },
  methods: {
    isShorikbREFER,
    // 自画面を閉じる
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    // キャンセル
    handleCancel() {
      this.hide(false);
    },
    // OK
    // async handleSave() {
    //   this.childHeaderInput.hatchuRenrakuJiko = this.hatchuRenrakuJiko;
    //   this.$emit('update:show', false);
    //   this.$emit('hide');
    // },
  },
});
